/**
 * Object of fields to be sent to NetSuite to update Vendor
 */

import { keyBy } from 'lodash';

export default keyBy(['phone', 'country', 'address', 'city', 'zip']);
